import React from "react";
import { RaisedButton } from "material-ui";
import DisplayAdPanel from "./partials/display-ad-panel.jsx";

export default class extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ads: this.props.ads
    };

    this.onAddItem = this.onAddItem.bind(this);
    this.onUpdateItem = this.onUpdateItem.bind(this);
    this.onDeleteItem = this.onDeleteItem.bind(this);
    this.onItemShiftPosition = this.onItemShiftPosition.bind(this);
  }

  onAddItem() {
    var addArray = this.state.ads.slice(0);
    addArray.push({
      url: null,
      image: null
    });
    this.setState({ ads: addArray });
    this.props.onUpdate(addArray);
  }

  onUpdateItem(index, field, value) {
    var updateArray = this.state.ads.slice(0);
    updateArray[index][field] = value;
    this.setState({ ads: updateArray });
    this.props.onUpdate(updateArray);
  }

  onDeleteItem(index) {
    var deleteArray = this.state.ads.slice(0);
    deleteArray.splice(index, 1);
    this.setState({ ads: deleteArray });
    this.props.onUpdate(deleteArray);
  }

  onItemShiftPosition(idx, direction) {
    var positionArray = this.state.ads.slice(0);
    positionArray.splice(idx + direction, 0, positionArray.splice(idx, 1)[0]);
    this.setState({ ads: positionArray });
    this.props.onUpdate(positionArray);
  }

  getStyles() {
    return {
      displayadpanel: {
        display: "flex",
        flexDirection: "column",
        justify: "start",
        flexWrap: "wrap",
        marginTop: 15
      },
      addbutton: {
        marginBottom: 10
      }
    };
  }

  render() {
    var styles = this.getStyles();

    return (
      <div>
        <div style={styles.displayadpanel}>
          {this.state.ads.map((item, index) => {
            return (
              <DisplayAdPanel
                key={index}
                keyval={index}
                url={item.url}
                image={item.image}
                onUpdate={this.onUpdateItem}
                onDelete={this.onDeleteItem}
                canShiftUp={index > 0}
                canShiftDown={index < this.state.ads.length - 1}
                onShiftPosition={(idx, direction) => {
                  this.onItemShiftPosition(idx, direction);
                }}
              />
            );
          })}
        </div>
        <RaisedButton
          style={styles.addbutton}
          label="Add another display ad"
          onTouchTap={this.onAddItem}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/components/display-ad-editor.jsx